import {
  Building2,
  CalendarCheck,
  CalendarClock,
  Car,
  Check,
  CircleHelp,
  HelpCircle,
  Home,
  Info,
  Laptop,
  Layers,
  Leaf,
  Monitor,
  MoonStar,
  ShieldCheck,
  Smartphone,
  Snowflake,
  Square,
  Sun,
  Timer,
  Tv,
  X,
  Zap,
} from 'lucide-react';

/**
 * Lucide icon names accepted from survey schema `icon` fields (question or option).
 * Keep in sync with backend question definitions.
 */
const SURVEY_ICON_MAP = {
  Building2,
  CalendarCheck,
  CalendarClock,
  Car,
  Check,
  /** Lucide alias; backend may send either */
  CircleHelp,
  HelpCircle,
  Home,
  Info,
  Laptop,
  Layers,
  Leaf,
  Monitor,
  MoonStar,
  ShieldCheck,
  Smartphone,
  Snowflake,
  Square,
  Sun,
  Timer,
  Tv,
  X,
  Zap,
};

export function getSurveyIconComponent(name) {
  if (!name || typeof name !== 'string') return null;
  return SURVEY_ICON_MAP[name] || null;
}
